// snake_case vs. camelCase

import _ from 'lodash'

export function objectKeysToCamelCase(snakeCaseObject) {
  if (_.isArray(snakeCaseObject))
    return snakeCaseObject.map(value => objectKeysToCamelCase(value))

  if (!_.isPlainObject(snakeCaseObject)) return snakeCaseObject

  const camelCaseObject = {}
  _.forEach(snakeCaseObject, (value, key) => {
    camelCaseObject[_.camelCase(key)] = objectKeysToCamelCase(value)
  })
  return camelCaseObject
}

export function objectKeysToSnakeCase(camelCaseObject) {
  if (_.isArray(camelCaseObject))
    return camelCaseObject.map(value => objectKeysToSnakeCase(value))

  if (!_.isPlainObject(camelCaseObject)) return camelCaseObject

  const snakeCaseObject = {}
  _.forEach(camelCaseObject, (value, key) => {
    snakeCaseObject[_.snakeCase(key)] = objectKeysToSnakeCase(value)
  })
  return snakeCaseObject
}
